import React, { useState, useEffect } from "react";
import "./App.css";

const companyLogos = [
  "Dialogic.jpg", "Schaeffler.png", "Thasmai_infotech.png", "amadeus.jpg",
  "crompton-greaves-logo.webp", "enphase_energy.jpg", "iTelematics.jpg",
  "intel-security-group-logo.png", "mcafee.jpg", "ness.jpg",
  "nms_communications.avif", "skill-lync.png", "tcs.jpg", "evsocietyofindia.jpg"
];

const instituteLogos = [
  "Padre.jpg", "SDMC.png", "Sahyadri.png", "Srinivasa.png", "ajiet-logo.svg",
  "canara.png", "iitm_code.webp", "mite-logo.svg", "nitk.png", "snmp.png"
];

function App() {
  // Detect if mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    // Auto-collapse after 2 seconds
    const timer = setTimeout(() => {
      setIsExpanded(false);
    }, 2000);

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="App">

      <SectionBox title="🚀 EV.ENGINEER™ – Industry-Grade Electric Mobility & AI Engineering Program 🚀">

        <p>Need mentorship or project guidance from industry experts? </p>

        {/* Book a Session Button */}
        <a className="back-btn" target="_blank" rel="noreferrer" href="https://topmate.io/sudarshana_karkala">
          Book a Workshop
        </a>

      </SectionBox>

      <section className="collaborations-section">
        <div className="section-header-flex">
          <h1>Contributions · Collaborations · Consulting Engagements</h1>
          <button
            className="toggle-expand-btn"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "Collapse View −" : "Expand View +"}
          </button>
        </div>

        {/* Floating Collapse Button for Mobile Anytime Access */}
        {isMobile && isExpanded && (
          <button
            className="floating-collapse-btn"
            onClick={() => setIsExpanded(false)}
            aria-label="Collapse Menu"
          >
            Collapse View −
          </button>
        )}

        <div className={`expandable-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
          <h2 className="sub-section-title">Organizations We’ve Worked With</h2>
          <div className="logo-grid">
            {companyLogos.map((logo, index) => (
              <div className="logo-card" key={index}>
                <img src={`/logo/companies/${logo}`} alt="Company Logo" />
              </div>
            ))}
          </div>

          <h2 className="sub-section-title">University & Institute Collaborations</h2>
          <div className="logo-grid">
            {instituteLogos.map((logo, index) => (
              <div className="logo-card" key={index}>
                <img src={`/logo/institutes/${logo}`} alt="Institute Logo" />
              </div>
            ))}
          </div>

          <p className="footer-disclaimer">
            Logos are displayed for informational purposes only and represent past or ongoing professional engagements. No endorsement is implied.
          </p>
        </div>
      </section>


      <header className="header-bar">
        <h1 className="left-title" > iOS, GenAI, Agentic AI - Corporate Training </h1>
        <h1 className="right-title" > Skill-Lync.com</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Corporate & Industry details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[

            [
              "Nov 2025",
              "Smart Home - iOS Application Development & Architecture",
              <>
                <div style={{ lineHeight: "1.8" }}>

                  <a href="https://www.facebook.com/media/set/?vanity=evsociety.org&set=a.1344635620783142" target="_blank" rel="noreferrer"> Crompton Greaves Consumer Electricals Ltd. Mumbai</a>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,

              <>
                <div style={{ lineHeight: "1.8" }}>
                  Engaged as a Strategic iOS & Smart Home Architecture Consultant for Crompton Greaves Consumer Electricals Ltd. Mumbai, driving next-generation connected product innovation.
                </div>
              </>



            ],
            [
              "Dec 2025",
              "GenAI - Corporate Training Program",
              <>
                <div style={{ lineHeight: "1.8" }}>

                  <a href="https://www.facebook.com/media/set/?vanity=evsociety.org&set=a.1374122771167760" target="_blank" rel="noreferrer"> Schaeffler India </a>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,

              <>
                <div style={{ lineHeight: "1.8" }}>
                  Schaeffler India - GenAI for Automotive & Embedded Engineering - Corporate Training Program
                </div>
              </>



            ]

          ]}
        />
      </SectionBox>
      <br />

      {/* Header */}
      <header className="header-bar">
        <h1 className="left-title" > Canara Engineering College, Mangalore </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>

      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2026-27",
              "EV Battery Pack Aadhar Systems - Design & Development",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  Nisarga<br />
                  Namitha <br />
                  Nandita Kini<br />
                  Rakshitha <br />

                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  Dr. Nagesh H R<br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <>
                <a href="https://github.com/CARSOFTWARESYSTEMS/EVBattery_Playground/" target="_blank" rel="noreferrer">Report / GitHub</a><br />
                <a href="https://itelematics.com/public/EV.ENGINEER%20-%20Battery%20Pack%20Aadhaar%20-%20Krutarth%20S%20Karkala.pdf"> Krutarth's Document</a>
              </>
            ],
            [
              "2025-26",
              "AI-Powered EV Battery Fire Prevention System",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  Shreelakshmi<br />
                  Komal <br />
                  Siddarth Kini<br />
                  Jagath <br />
                  Kshithij Raj<br />
                  Manish Shetty<br />
                  Wafiq<br />
                  Rashmi Rao<br />
                  Samartha<br />
                  Prashant Pinto<br />
                  Vishal Prabhu
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  Dr. Nagesh H R<br />
                  Dr. Basappa Kodada<br />
                  Sreerama Samatha J G<br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <a href="https://github.com/CARSOFTWARESYSTEMS/EVBattery_Playground/" target="_blank" rel="noreferrer">Report / GitHub</a>
            ],
            [
              "2025-26",
              "EV.ENGINEER: AI Driven Next-Gen EV Engineer's Profile Management System",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  Dr. Nagesh H R<br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>

              </>,
              <span>Proposal Submitted</span>
            ],
            [
              "2025-26",
              "Advanced Gen AI & Agentic AI - From Basics to Practical Implementation",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  Dr. Nagesh H R<br />
                  Dr. Basappa Kodada<br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>

              </>,
              <a href="https://carsoftwaresystems.com/public/AI/Gen%20AI%20&%20Agentic%20AI%20-%20Design%20Patterns.pdf" target="_blank" rel="noreferrer">Advanced Gen AI & Agentic AI</a>
            ]
          ]}
        />
      </SectionBox>
      <br />
      <header className="header-bar">
        <h1 className="left-title" > National Institute of Technology Karnataka, Surathkal </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[

            [
              "2025-30",
              <a href="http://battery.ev.engineer/" target="_blank" rel="noreferrer">EV Battery Health & Diagnostics</a>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <span><a href="https://www.evsociety.org/projects/battery-safety-systems/candidates" target="_blank" rel="noreferrer">Candidates /Interns</a></span>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://labs.ev.engineer/battery/Shilajit_Das.html" target="_blank" rel="noreferrer">Shilajit Das</a>
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>

                </div>
              </>,
              <span><a href="http://battery.ev.engineer/" target="_blank" rel="noreferrer">BATTERY.EV.ENGINEER</a></span>
            ],
            [
              "2025-26",
              "NITK Alumni Projects",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ]

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > NMAM Institute of Technology (NMAMIT) – Nitte </h1>
        <h1 className="right-title" > CAR Software Systems </h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[

            [
              "2001-02",
              "College Timetable Generator",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <span>Vijayalaxmi and team</span>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>

                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ]

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > Manipal Institute of Technology – Manipal </h1>
        <h1 className="right-title" > EV.ENGINEER™ </h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[

            [
              "2026-27",
              "EV Battery Intelligence",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <span>Candidates /Interns</span>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>

                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ]

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" >  Corporate Employee / Institute Training </h1>
        <h1 className="right-title" > Thasmai Infotech Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[

            [
              "2025-26",
              "Advanced Gen AI & Agentic AI - From Basics to Practical Implementation",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.thasmaiinfotech.com/team/sudarshanakarkala" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>

              </>,
              <a href="https://www.thasmaiinfotech.com/training/ai/Thasmai%20-%20Gen%20AI%20&%20Agentic%20AI%20-%20Design%20Patterns.pdf" target="_blank" rel="noreferrer">Advanced Gen AI & Agentic AI</a>
            ]

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > Telematics & EV Training Programs </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[

            [
              "2025-26",
              "AI-powered Electric Vehicle Tracking System & Fleet Intelligence",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>

              </>,
              <a href="https://carsoftwaresystems.com/public/AI/AI-POWERED%20ELECTRIC%20VEHICLE%20TRACKING%20SYSTEM%20AND%20FLEET%20INTELLIGENCE.pdf" target="_blank" rel="noreferrer">EV Tracking</a>
            ],
            [
              "2025-26",
              "Advanced Gen AI & Agentic AI - From Basics to Practical Implementation",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>

              </>,
              <a href="https://carsoftwaresystems.com/public/AI/Gen%20AI%20&%20Agentic%20AI%20-%20Design%20Patterns.pdf" target="_blank" rel="noreferrer">Advanced Gen AI & Agentic AI</a>
            ],
            [
              "2025-26",
              "AI-Powered Telematics & EV Battery Fire Prevention System",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>

              </>,
              <a href="https://itelematics.com/public/iTelematics.pdf" target="_blank" rel="noreferrer">AI Battery & Telematics</a>
            ],

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > Electric Vehicle & Tracking Training Program </h1>
        <h1 className="right-title" >ACTE</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[

            [
              "2025-26",
              "Vehicle Tracking System & Fleet Intelligence",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>

              </>,
              <span>Vehicle Tracking in Dubai & UAE</span>
            ]


          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > A J Institute of Engineering & Technology, Mangalore </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2025-26",
              "EV Project",
              <>
                <div style={{ lineHeight: "1.8" }}>

                  Manvith<br />
                  Rishab <br />
                  Asha<br />
                  Sudharshan <br />
                  Ashwjia<br />
                  Mouseen<br />
                  Nandesh<br />
                  Amrutha<br />

                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  Dr. Kiran Kumar V G<br />
                  Mr. Harsha C J <br />
                  Mrs. Rekha A A <br />
                  Mrs. Sridevi D Rai<br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <a href="https://github.com/CARSOFTWARESYSTEMS/EVBattery_Playground/" target="_blank" rel="noreferrer">Report / GitHub</a>
            ],

          ]}
        />
      </SectionBox>


      <br />
      <header className="header-bar">
        <h1 className="left-title" > Srinivasa Institute of Technology, Mangalore (SIT) </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2026-27",
              "Autonomous EV Cargo Vehicle Project",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ],

          ]}
        />
      </SectionBox>


      <br />
      <header className="header-bar">
        <h1 className="left-title" > Padre Conceicao College of Engineering, South Goa </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2016-17",
              "IoT & Telematics Project / Workshop - 2 days",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>

                  <br />
                  <a href="https://www.linkedin.com/in/ashwinisudarshana/" target="_blank" rel="noreferrer">Ashwini Sudarshana</a><br />
                </div>
              </>,

            ],

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > Sahyadri College of Engineering & Management, Mangaluru </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2025-26",
              "EV Operating System - Research",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <span>Mr. Prajwal Rao</span><br />
                  <span>Mr Kishore Kumar</span>
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Mr. Sudarshana Karkala</a><br />
                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ],

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > SDM Engineering College Ujire </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2025-26",
              "AI / Quantum Computing Project",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ],

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > SNM Polytechnic Moodbidri </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2025-26",
              "Timetable Automation",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ],

          ]}
        />
      </SectionBox>


      <br />
      <header className="header-bar">
        <h1 className="left-title" > Malnad College of Engineering Hassan </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2025-26",
              "EV Project",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ],

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > BGS Institute of Technology (BGSIT), Mandya </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2025-26",
              "EV & Drone Project",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ],

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > Other Colleges / University </h1>
        <h1 className="right-title" > iTelematics Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2025-26",
              "EV & Battery Project",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://labs.ev.engineer/Internships/Engineering/DSCE/EEE/Anirudh_Kosgi.html" target="_blank" rel="noreferrer">Anirudh Kosgi</a> <br />
                  <a href="https://labs.ev.engineer/Internships/Engineering/BMS/ISE/Sai_Gagan_Sirigeri.html" target="_blank" rel="noreferrer">Sai Gagan Sirigeri</a><br />
                  <span>Preksha KP</span><br />
                  <span>Vedashree</span><br />
                  <span>Vanitha</span><br />

                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>

                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <span>Report / GitHub (Coming Soon)</span>
            ],

          ]}
        />
      </SectionBox>


      <br />
      <header className="header-bar">
        <h1 className="left-title" > Mangalore Institute of Technology and Engineering, MITE </h1>
        <h1 className="right-title" > McAfee Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2017-20",
              "IoT & Telematics Security Projects",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  Computer Science & Engineering Department<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/dr-venkatramana-bhat-p-042b738/" target="_blank" rel="noreferrer"> Dr. Venkatramana Bhat P</a><br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/overlay/volunteering-experiences/1464862462/multiple-media-viewer/?profileId=ACoAAAJKGCMB-9ydba1RRPEUW8U9eAsRos_4HB8&treasuryMediaId=1755959003465" target="_blank" rel="noreferrer">Invitation</a><br />
                  <a href="https://www.linkedin.com/feed/update/urn:li:activity:6602924667923771392/" target="_blank" rel="noreferrer">McAfee Student Developer Program</a>
                </div>
              </>
            ]

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > CSR - McAfee Student Developer Program </h1>
        <h1 className="right-title" > McAfee Software Private Limited</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2014-20",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  CSR Program <br />
                  McAfee Student Developer Program<br /><br />
                  Cyber Security, IoT, Mobile Telematics Workshops<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>

                  Workshops, Seminars and Project guidance in schools and colleges: <br /><br />

                  - National Institute of Technology Surathkal, Karnataka (NITK)<br />
                  - Mangalore Institute of Technology & Engineering (MITE)<br />
                  - Sanjeeva Narayana Moodbidri Polytechnic (SNMP)<br />
                  - AJ Engineering College, Mangalore.<br />
                  - SDM Engineering College Ujire<br />
                  - Srinivasa Institute of Technology, Mangalore (SIT)<br />
                  - Sri Jayachamarajendra College Of Engineering, Mysore (SJC)<br />
                  - NGO : Katalyst, Bangalore (http://katalystindia.org)

                  <br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/feed/update/urn:li:activity:6602924667923771392/" target="_blank" rel="noreferrer">McAfee Student Developer Program</a><br />
                  <a href="https://www.facebook.com/evsociety.org" target="_blank" rel="noreferrer">EV Society(.org)</a>


                </div>
              </>
            ]

          ]}
        />
      </SectionBox>

      <br />
      <header className="header-bar">
        <h1 className="left-title" > SRM INSTITUTE OF SCIENCE AND TECHNOLOGY, TRICHY </h1>
        <h1 className="right-title" > EV Society</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2026 - Till now",
              <a href="https://labs.ev.engineer/Internships/Rocketry/astroforge.html" target="_blank" rel="noreferrer">AstroForge Model Rocketry Mission Architecture</a>,

              <>
                <div style={{ lineHeight: "1.8" }}>
                  Suvranil Mondal <br />
                  Shalini R  <br />
                  Harini N S   <br />
                  Marimuthu R  <br />
                  Harish Joshua MV  <br />
                  Grandhi pranay  <br />
                  Muhammad Salman S  <br />
                  Lana Iqbal  <br />


                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  B V Manjunath <br />
                  <a href="https://www.linkedin.com/in/sharanya-rajaram-b96a201b8/" target="_blank" rel="noreferrer">Sharanya Rajaram</a>  <br />
                  <a href="https://www.linkedin.com/in/ashwinisudarshana/" target="_blank" rel="noreferrer">Ashwini Sudarshana</a>  <br />
                  <a href="https://carsoftwaresystems.com/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>  <br />

                  <br />
                  <br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <span> Report / GitHub (Coming Soon)</span> <br />
                  <a href="https://labs.ev.engineer/Internships/Rocketry/astroforge.html" target="_blank" rel="noreferrer">AstroForge Model Rocketry Mission Architecture</a> <br />
                  <a href="https://www.facebook.com/evsociety.org" target="_blank" rel="noreferrer">EV Society (.org)</a>
                </div>
              </>,

            ]


          ]}
        />
      </SectionBox>


      <br />
      <header className="header-bar">
        <h1 className="left-title" > Research Projects </h1>
        <h1 className="right-title" > EV Society</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2025 - Till now",
              "EV & AI/ML,  IoT/Drone ",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://labs.ev.engineer/students/team1/Krutarth_S_Karkala.html" target="_blank" rel="noreferrer">Krutarth S Karkala</a>  <br />
                  <br />
                  <br />
                  <br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  [Add names here]
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Mentor Profile</a>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <span> Report / GitHub (Coming Soon)</span> <br />
                  <a href="https://www.facebook.com/evsociety.org" target="_blank" rel="noreferrer">EV Society</a>
                </div>
              </>,

            ],
            [
              "2025-30",
              <a href="http://battery.ev.engineer/" target="_blank" rel="noreferrer">EV Battery Health & Diagnostics</a>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <span><a href="https://www.evsociety.org/projects/battery-safety-systems/candidates" target="_blank" rel="noreferrer">Candidates /Interns</a></span>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://labs.ev.engineer/battery/Shilajit_Das.html" target="_blank" rel="noreferrer">Shilajit Das</a>
                  <br />
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>

                </div>
              </>,
              <span><a href="http://battery.ev.engineer/" target="_blank" rel="noreferrer">BATTERY.EV.ENGINEER</a></span>
            ],


          ]}
        />
      </SectionBox>




      <br />
      <header className="header-bar">
        <h1 className="left-title" >  National Institute of Technology Karnataka, Surathkal </h1>
        <h1 className="right-title" > NITK Alumni Association, Bangalore Chapter</h1>
      </header>
      {/* Profile Section */}
      <SectionBox title="">
        <ResponsiveTable
          isMobile={isMobile}
          headers={[
            "Year",
            "Project Title",
            "Students / Interns details",
            "Under the guidance of",
            "Comments / Reports / Publications"
          ]}
          rows={[
            [
              "2001-Till Now",
              <>
                <div style={{ lineHeight: "1.8" }}>
                  Alumni - Education & Community Service Projects <br />
                  Wireless-School.org - EV Society(.org) <br />
                  CAR Software Systems @ SNMP - 2001 <br />
                  College Timetable Automation @ SNMP - 2000<br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>

                  Workshops, Seminars and Project guidance in schools and colleges: <br /><br />

                  - NMAMIT - Nitte Mahalinga Adyantaya Memorial Institute of Technology <br />
                  - Sanjeeva Narayana Moodbidri Polytechnic (SNMP)<br />
                  - SDM College Ujire<br />
                  - Alva's College, Moodubidire<br />
                  - National Institute of Technology Karnataka, Surathkal (NITK)<br />
                  - +++ ...
                  <br />
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.linkedin.com/in/sudarshanakarkala/" target="_blank" rel="noreferrer">Sudarshana Karkala</a>
                </div>
              </>,
              <>
                <div style={{ lineHeight: "1.8" }}>
                  <a href="https://www.facebook.com/evsociety.org" target="_blank" rel="noreferrer">EV Society(.org)</a>


                </div>
              </>
            ]

          ]}
        />
      </SectionBox>

      <SectionBox title="">


        <a className="back-btn" target="_blank" rel="noreferrer" href="http://evsociety.org/">
          EVSociety.org
        </a>&nbsp;&nbsp;

        <a className="back-btn" target="_blank" rel="noreferrer" href="https://itelematics.com/">
          iTelematics®
        </a>&nbsp;&nbsp;

        <a className="back-btn" target="_blank" rel="noreferrer" href="https://ev.engineer/">
          EV.Engineer™
        </a>&nbsp;&nbsp;

        <a className="back-btn" target="_blank" rel="noreferrer" href="https://carsoftwaresystems.com/">
          CAR Software Systems
        </a>&nbsp;&nbsp;

        <a className="back-btn" target="_blank" rel="noreferrer" href="https://labs.ev.engineer/research_papers/call_for_papers.html">
          Call for Papers
        </a>

      </SectionBox>


      <br />
      {/* Back Button */}
      <a className="back-btn" href="https://labs.ev.engineer">
        ⬅ Back to Home
      </a>
    </div>
  );
}

// Section Wrapper
const SectionBox = ({ title, children }) => (
  <div className="section info-box">
    {title && <h2>{title}</h2>}
    <div>{children}</div>
  </div>
);

// Responsive Table -> switches to cards on mobile
const ResponsiveTable = ({ headers, rows, isMobile }) => {
  if (!isMobile) {
    return (
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>{headers.map((h, i) => <th key={i}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr key={ri}>{row.map((cell, ci) => <td key={ci}>{cell}</td>)}</tr>
            ))}


          </tbody>
        </table>
      </div>
    );
  }

  // Mobile card layout
  return (
    <div className="card-list">
      {rows.map((row, ri) => (
        <div className="card" key={ri}>
          {row.map((cell, ci) => (
            <p key={ci}>
              <strong>{headers[ci]}:</strong> {cell || "-"}
            </p>
          ))}
        </div>
      ))}
    </div>
  );
};

export default App;
